import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

// Switch global de tema (Sol/Luna) para el encabezado de las vistas operativas.
export default function ThemeToggle({ withLabel = true }) {
  const { sunMode, toggleSunMode } = useTheme();
  return (
    <button
      onClick={toggleSunMode}
      data-testid="theme-toggle"
      data-sun-mode={sunMode ? "1" : "0"}
      title={sunMode ? "Cambiar a Modo Luna (oscuro)" : "Cambiar a Modo Sol (claro, alto contraste)"}
      className={`btn-hard h-10 px-3 border flex items-center gap-2 text-xs font-bold uppercase tracking-wider transition-colors ${
        sunMode
          ? "bg-[#FFCC00] border-[#C79A00] text-[#1A1A1A] hover:bg-[#e6b800]"
          : "bg-white/5 border-white/20 text-white/70 hover:bg-white/10"
      }`}
    >
      {sunMode ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
      {withLabel && <span className="hidden lg:inline">{sunMode ? "Modo Luna" : "Modo Sol"}</span>}
    </button>
  );
}
